module.exports = __webpack_public_path__ + "img/BG.19c9f117.svg";